import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Listfileupload from "components/Uploadfile/Chucnang/Listfileupload.js";
import Progress from "react-progressbar";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import axios from "axios";
import Config from "conFig.js";
import { Error, Success } from "../../../assets/jss/util/messageUtil";

export default function Themvanban() {
  const [sokyhieu, setSokyhieu] = React.useState("");
  const [ngayvanban, setNgayvanban] = React.useState(dayjs());
  const [trichyeu, setTrichyeu] = React.useState("");
  //const [loaivipham, setLoaivipham] = React.useState([]);
  //const [loaiviphamvalue, setLoaiviphamvalue] = React.useState(0);
  const [loaivanban, setLoaivanban] = React.useState([]);
  const [loaivanbanvalue, setLoaivanbanvalue] = React.useState(0);
  const [coquanbanhanh, setCoquanbanhanh] = React.useState([]);
  const [coquanbanhanhvalue, setCoquanbanhanhvalue] = React.useState(0);
  const [nguoiky, setNguoiky] = React.useState("");
  const [selectedFiles, setSelectedFiles] = React.useState(undefined);
  const [progressInfos, setProgressInfos] = React.useState([]);
  const [tenfile, setTenfile] = React.useState([]);
  const [listfile, setListfile] = React.useState([]);
  let progresstemp = [];
  let bodyFormData = new FormData();
  const [message, setMessage] = React.useState([]);
  const [alert, setAlert] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json, text/plain",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };
  // const getloaivipham = () => {
  //   var url =
  //     Config.backend + "/api/Vipham/getdmloaivipham?username=" + username;
  //   fetch(url, obj)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setLoaivipham(data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data: ", error);
  //     });
  // };
  const getloaivanban = () => {
    var url =
      Config.backend + "/api/QLVanBan/getdmloaivanban?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setLoaivanban(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcoquanbanhanh = () => {
    var url =
      Config.backend +
      "/api/donvi/getdonvitheoloaidonvi?dmloaidonvi_id=11&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setCoquanbanhanh(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const selectFiles = (event) => {
    setProgressInfos([]);
    setSelectedFiles(event.target.files);
  };
  const upload = (idx, file) => {
    let _progressInfos = progresstemp;
    _progressInfos[idx].percentage = Math.round(
      (100 * event.loaded) / event.total
    );
    setProgressInfos(_progressInfos);
    setTenfile((oldArray) => [...oldArray, { filename: file.name }]);
    setListfile((oldArray1) => [...oldArray1, file]);
  };

  const uploadFiles = () => {
    const selectedFiless = selectedFiles;

    let _progressInfos = [];

    for (let i = 0; i < selectedFiless.length; i++) {
      _progressInfos.push({ percentage: 0, fileName: selectedFiless[i].name });
    }
    setProgressInfos(_progressInfos);
    progresstemp = _progressInfos;
    setMessage([]);
    for (let i = 0; i < selectedFiles.length; i++) {
      upload(i, selectedFiles[i]);
    }
  };
  const xoafile = (id, key) => {
    setTenfile((current) => current.filter((item, index) => index !== id));
    setListfile((current) => current.filter((item, index) => index !== id));
    bodyFormData.delete(key);
  };
  const insertvanban = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngayvb =
        ngayvanban.$y +
        "-" +
        String(ngayvanban.$M + 1).padStart(2, "0") +
        "-" +
        ngayvanban.$D;
      var url = Config.backend + "/api/QLVanBan/CreateVanBan";
      bodyFormData.append("sokyhieu", sokyhieu);
      bodyFormData.append("ngaybanhanh", ngayvb);
      bodyFormData.append("trichyeu", trichyeu);
      bodyFormData.append("theloaivanbanid", 1);
      //bodyFormData.append("loaiviphamid", loaiviphamvalue);
      bodyFormData.append("loaivanbanid", loaivanbanvalue);
      bodyFormData.append("coquanbanhanhid", coquanbanhanhvalue);
      bodyFormData.append("nguoiky", nguoiky);
      bodyFormData.append("ngaycn", ngayvb);
      bodyFormData.append("nguoicn", username);
      listfile.map((item) => {
        bodyFormData.append("File", item);
      });
      axios
        .post(url, bodyFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (response) {
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
      showNotification();
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra cac truong bat buoc nhap
    if (sokyhieu.trim() === "") {
      return Error.ER0025;
    }
    if (trichyeu.trim() === "") {
      return Error.ER0021;
    }
    // if (!loaiviphamvalue || loaiviphamvalue === 0) {
    //   return Error.ER0022;
    // }
    if (!loaivanbanvalue || loaivanbanvalue === 0) {
      return Error.ER0023;
    }
    if (!coquanbanhanhvalue || coquanbanhanhvalue === 0) {
      return Error.ER0024;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    //getloaivipham();
    getcoquanbanhanh();
    getloaivanban();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số ký hiệu"
                variant="outlined"
                size="small"
                value={sokyhieu}
                onChange={(event) => {
                  setSokyhieu(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "8px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày ban hành"
                  value={ngayvanban}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayvanban(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Trích yếu"
                variant="outlined"
                size="small"
                value={trichyeu}
                onChange={(event) => {
                  setTrichyeu(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          {/* <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={loaivipham}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setLoaiviphamvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaiviphamvalue(null);
                  } else {
                    setLoaiviphamvalue(
                      loaivipham.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại vi phạm"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem> */}
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={loaivanban}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setLoaivanbanvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setLoaivanbanvalue(null);
                  } else {
                    setLoaivanbanvalue(
                      loaivanban.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Loại văn bản"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={coquanbanhanh}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setCoquanbanhanhvalue(value.id);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setCoquanbanhanhvalue(null);
                  } else {
                    setCoquanbanhanhvalue(
                      coquanbanhanh.find(({ ten }) => ten === newInputValue).id
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cơ quan ban hành"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Người ký"
                variant="outlined"
                size="small"
                value={nguoiky}
                onChange={(event) => {
                  setNguoiky(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <FormControl
              style={{ width: "99%", marginTop: "10px", marginLeft: "4px" }}
            >
              {progressInfos &&
                progressInfos.map((progressInfo, index) => (
                  <div className="mb-2" key={index}>
                    <span>{progressInfo.fileName}</span>
                    <div className="progress">
                      <Progress completed={progressInfo.percentage} />
                    </div>
                  </div>
                ))}

              <div className="row my-3">
                <div className="col-8">
                  <label className="btn btn-default p-0">
                    <input type="file" multiple onChange={selectFiles} />
                  </label>
                </div>
                <div className="col-4">
                  <button
                    style={{ width: "70px", marginTop: 10 }}
                    disabled={!selectedFiles}
                    onClick={uploadFiles}
                  >
                    Upload
                  </button>
                </div>
              </div>

              {message.length > 0 && (
                <div className="alert alert-secondary" role="alert">
                  <ul>
                    {message.map((item, i) => {
                      return <li key={i}>{item}</li>;
                    })}
                  </ul>
                </div>
              )}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={10} md={12}>
            <Listfileupload tenfile={tenfile} xoafile={xoafile} />
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={insertvanban}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
